var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.$store.state.displayType === "textual"
    ? _c("default-textual-section", {
        staticClass: "menu--section-christmas_dining",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
          "section-menu-type": "DINING",
        },
        scopedSlots: _vm._u(
          [
            {
              key: "sectionTitleImage",
              fn: function () {
                return [
                  _c("h2", [
                    _c("img", {
                      staticClass: "menu--section_logo",
                      attrs: {
                        src: "/library/images/menu/header-christmas-dining-2025.png",
                        alt: "Christmas Dining",
                      },
                    }),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "beforeTopContentArea",
              fn: function () {
                return [
                  _c(
                    "h2",
                    {
                      staticClass: "menu--section_title",
                      attrs: { tabindex: "-1" },
                    },
                    [
                      _vm._v(
                        "\n      " + _vm._s(_vm.menu.page.page_h1) + "\n    "
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          false,
          2793012942
        ),
      })
    : _c("default-visual-section", {
        staticClass: "menu--section-christmas_dining",
        attrs: {
          menu: _vm.menu,
          section: _vm.section,
          "menu-item-component": _vm.menuItemComponent,
          "section-menu-type": "DINING",
        },
        scopedSlots: _vm._u([
          {
            key: "sectionTitleImage",
            fn: function () {
              return [
                _c("h2", [
                  _c("img", {
                    staticClass: "menu--section_logo",
                    attrs: {
                      src: "/library/images/menu/header-christmas-dining-2025.png",
                      alt: "Christmas Dining",
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "beforeTopContentArea",
            fn: function () {
              return [
                _c(
                  "h2",
                  {
                    staticClass: "menu--section_title",
                    attrs: { tabindex: "-1" },
                  },
                  [
                    _vm._v(
                      "\n      " + _vm._s(_vm.menu.page.page_h1) + "\n    "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }